// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function SurveyBuilderMobilePreview(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                              className: "h-14-px opacity-60",
                              src: Image$ReactHooksTemplate.preview
                            }),
                        "Live Preview"
                      ],
                      className: "sb-preview-label"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "9:41",
                                            className: "sb-phone-time"
                                          }),
                                      JsxRuntime.jsxs("span", {
                                            children: [
                                              JsxRuntime.jsxs("svg", {
                                                    children: [
                                                      JsxRuntime.jsx("rect", {
                                                            height: "4",
                                                            width: "3",
                                                            rx: "0.5",
                                                            x: "0",
                                                            y: "8"
                                                          }),
                                                      JsxRuntime.jsx("rect", {
                                                            height: "6.5",
                                                            width: "3",
                                                            rx: "0.5",
                                                            x: "5",
                                                            y: "5.5"
                                                          }),
                                                      JsxRuntime.jsx("rect", {
                                                            height: "9",
                                                            width: "3",
                                                            rx: "0.5",
                                                            x: "10",
                                                            y: "3"
                                                          }),
                                                      JsxRuntime.jsx("rect", {
                                                            height: "12",
                                                            width: "3",
                                                            rx: "0.5",
                                                            x: "15",
                                                            y: "0"
                                                          })
                                                    ],
                                                    className: "sb-phone-ic",
                                                    fill: "currentColor",
                                                    viewBox: "0 0 18 12",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  }),
                                              JsxRuntime.jsxs("svg", {
                                                    children: [
                                                      JsxRuntime.jsx("path", {
                                                            d: "M8 2.2c2.7 0 5.2 1 7 2.8l-1.5 1.5A7.8 7.8 0 008 4.3 7.8 7.8 0 002.5 6.5L1 5C2.8 3.2 5.3 2.2 8 2.2z"
                                                          }),
                                                      JsxRuntime.jsx("path", {
                                                            d: "M8 6c1.5 0 2.9.6 3.9 1.6l-1.5 1.5A3.4 3.4 0 008 8.1c-.9 0-1.8.4-2.4 1L4.1 7.6A5.5 5.5 0 018 6z"
                                                          }),
                                                      JsxRuntime.jsx("path", {
                                                            d: "M8 9.4c.7 0 1.3.3 1.7.8L8 11.9 6.3 10.2c.4-.5 1-.8 1.7-.8z"
                                                          })
                                                    ],
                                                    className: "sb-phone-ic",
                                                    fill: "currentColor",
                                                    viewBox: "0 0 16 12",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  }),
                                              JsxRuntime.jsxs("svg", {
                                                    children: [
                                                      JsxRuntime.jsx("rect", {
                                                            height: "10.8",
                                                            width: "22",
                                                            rx: "2.6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1",
                                                            x: "0.6",
                                                            y: "0.6"
                                                          }),
                                                      JsxRuntime.jsx("rect", {
                                                            height: "8",
                                                            width: "16.5",
                                                            fill: "currentColor",
                                                            rx: "1.3",
                                                            x: "2",
                                                            y: "2"
                                                          }),
                                                      JsxRuntime.jsx("rect", {
                                                            height: "4",
                                                            width: "1.6",
                                                            fill: "currentColor",
                                                            rx: "0.8",
                                                            x: "24",
                                                            y: "4"
                                                          })
                                                    ],
                                                    className: "sb-phone-ic sb-phone-ic--batt",
                                                    fill: "none",
                                                    viewBox: "0 0 26 12",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  })
                                            ],
                                            className: "sb-phone-signals"
                                          })
                                    ],
                                    className: "sb-phone-statusbar"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: props.children,
                                    className: "sb-phone-content"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "sb-phone-home"
                                  })
                            ],
                            className: "sb-phone-screen sb-phone-screen--builder"
                          }),
                      className: "sb-phone-frame"
                    })
              ],
              className: "sb-preview-section"
            });
}

var make = SurveyBuilderMobilePreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
